var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 578,
    height: 407,
    viewBox: "0 0 578 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M517.791 295.435L540.763 245.435L562.791 295.435H517.791Z",
    stroke: "url(#paint0_linear_8_3654)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.831 60C165.258 60 175.331 48.8071 175.331 35C175.331 21.1929 165.258 10 152.831 10C140.405 10 130.331 21.1929 130.331 35C130.331 48.8071 140.405 60 152.831 60Z",
    stroke: "url(#paint1_linear_8_3654)",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112 370.773H72C72 354.208 80.9526 340.773 92.0024 340.773C103.052 340.773 112 354.208 112 370.773Z",
    stroke: "url(#paint2_linear_8_3654)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 150.883L3 188.383L40.5 225.883L78 188.383L40.5 150.883Z",
    stroke: "url(#paint3_linear_8_3654)",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M449 333H379V403H449V333Z",
    stroke: "url(#paint4_linear_8_3654)",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M575 37L557.438 72H522.479L505 37L522.479 2H557.438L575 37Z",
    stroke: "url(#paint5_linear_8_3654)",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_3654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447 339.038V303.462C447 277.019 425.846 257.308 399.404 257.308H244.596C218.154 257.308 197 276.538 197 303.462V339.038H447Z",
    fill: "#00C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 305.385V339.038H447V305.385",
    fill: "#08B8BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 296.731C341.649 296.731 357.577 282.524 357.577 265C357.577 247.476 341.649 233.269 322 233.269C302.351 233.269 286.423 247.476 286.423 265C286.423 282.524 302.351 296.731 322 296.731Z",
    fill: "#36FFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.462 252.019C360.462 272.692 345.077 288.558 322.962 289.038C302.288 289.038 283.538 272.692 283.538 252.019V232.308C283.538 211.635 300.365 194.808 321.038 194.808H323.442C344.115 194.808 360.942 211.635 360.942 232.308V252.019H360.462Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.481 196.25C343.154 196.25 360.462 213.077 360.462 233.75V252.019C360.462 272.692 345.558 288.558 322.962 289.038",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.462 242.885V238.077H283.538V242.885",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.404 81.8269C324.404 83.2692 323.442 84.2308 322 84.2308C320.558 84.2308 319.596 83.2692 319.596 81.8269V43.3654C319.596 41.9231 320.558 40.9615 322 40.9615C323.442 40.9615 324.404 41.9231 324.404 43.3654V81.8269Z",
    fill: "#0B6382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 40.9615C323.923 40.9615 324.404 42.4039 324.404 43.8462V81.8269C324.404 83.75 323.923 84.2308 322 84.2308",
    fill: "#00233F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.615 79.4231H312.385V98.6539H331.615V79.4231Z",
    fill: "#F45683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.385 79.4231H331.615V98.6539",
    fill: "#E2336D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.404 81.8269H319.596V86.6346H324.404V81.8269Z",
    fill: "#00E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.596 48.6539H324.404V47.2115H319.596V48.6539Z",
    fill: "#15819E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.596 54.9039H324.404V53.4615H319.596V54.9039Z",
    fill: "#15819E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.596 61.1539H324.404V59.7115H319.596V61.1539Z",
    fill: "#15819E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.596 66.9231H324.404V65.4808H319.596V66.9231Z",
    fill: "#15819E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.596 73.1731H324.404V71.7308H319.596V73.1731Z",
    fill: "#15819E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.692 122.212C254.692 127.981 250.365 132.308 244.596 132.308H231.135C225.365 132.308 221.038 127.981 221.038 122.212V99.1346C221.038 93.3654 225.365 89.0385 231.135 89.0385H244.596C250.365 89.0385 254.692 93.3654 254.692 99.1346V122.212Z",
    fill: "#0B6382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.654 89.0385H244.115C249.885 89.0385 254.692 92.8846 254.692 98.6538V120.288C254.692 126.058 249.404 132.308 244.115 132.308H230.654",
    fill: "#00233F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.154 122.212C418.154 127.981 413.827 132.308 408.058 132.308H394.596C388.827 132.308 384.5 127.981 384.5 122.212V99.1346C384.5 93.3654 388.827 89.0385 394.596 89.0385H408.058C413.827 89.0385 418.154 93.3654 418.154 99.1346V122.212Z",
    fill: "#0B6382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.923 89.0385H408.538C414.308 89.0385 418.154 92.8846 418.154 98.6538V120.288C418.154 126.058 414.308 132.308 408.538 132.308H398.923",
    fill: "#00233F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.385 184.231C462.385 211.154 425.846 233.269 398.923 242.885H245.077C218.154 233.269 181.615 211.154 181.615 184.231L172 143.846C172 116.923 194.115 93.8461 221.519 93.8461H422.962C449.885 93.8461 472 116.923 472 143.846L462.385 184.231Z",
    fill: "#00E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 144.808L462.385 184.231C462.385 211.154 425.846 233.269 398.923 242.885H245.077C189.788 224.615 181.615 211.154 181.615 184.231L172 144.808",
    fill: "#00C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.385 184.231C462.385 211.154 425.846 233.269 398.923 242.885H245.077C184.019 223.654 181.615 205.865 181.615 184.231",
    fill: "#08B8BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.865 212.596C264.949 212.596 286.904 190.641 286.904 163.558C286.904 136.474 264.949 114.519 237.865 114.519C210.782 114.519 188.827 136.474 188.827 163.558C188.827 190.641 210.782 212.596 237.865 212.596Z",
    fill: "#0B6382"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.865 217.885C264.949 217.885 286.904 195.929 286.904 168.846C286.904 141.763 264.949 119.808 237.865 119.808C210.782 119.808 188.827 141.763 188.827 168.846C188.827 195.929 210.782 217.885 237.865 217.885Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.865 114.519C264.788 114.519 286.904 136.635 286.904 163.558C286.904 190.481 264.788 212.596 237.865 212.596",
    fill: "#00233F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.865 196.731C256.186 196.731 271.038 181.879 271.038 163.558C271.038 145.237 256.186 130.385 237.865 130.385C219.544 130.385 204.692 145.237 204.692 163.558C204.692 181.879 219.544 196.731 237.865 196.731Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.865 196.731C256.186 196.731 271.038 181.879 271.038 163.558C271.038 145.237 256.186 130.385 237.865 130.385C219.544 130.385 204.692 145.237 204.692 163.558C204.692 181.879 219.544 196.731 237.865 196.731Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.788 140C227.769 127.019 248.923 127.019 261.904 140C274.885 152.981 274.885 174.135 261.904 187.115",
    fill: "#EFEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.865 139.038C255.654 139.038 270.077 147.692 271.038 165.481C271.038 165 271.038 164.038 271.038 163.558C271.038 145.288 256.135 130.385 237.865 130.385C219.596 130.385 204.692 145.288 204.692 163.558C204.692 164.038 204.692 165 204.692 165.481C206.135 148.173 220.558 139.038 237.865 139.038Z",
    fill: "#CCCAC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.769 124.135C228.831 124.135 229.692 123.274 229.692 122.212C229.692 121.149 228.831 120.288 227.769 120.288C226.707 120.288 225.846 121.149 225.846 122.212C225.846 123.274 226.707 124.135 227.769 124.135Z",
    fill: "#CCCAC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.865 124.135C238.927 124.135 239.788 123.274 239.788 122.212C239.788 121.149 238.927 120.288 237.865 120.288C236.803 120.288 235.942 121.149 235.942 122.212C235.942 123.274 236.803 124.135 237.865 124.135Z",
    fill: "#CCCAC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 124.135C249.504 124.135 250.365 123.274 250.365 122.212C250.365 121.149 249.504 120.288 248.442 120.288C247.38 120.288 246.519 121.149 246.519 122.212C246.519 123.274 247.38 124.135 248.442 124.135Z",
    fill: "#CCCAC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.596 163.558C244.596 166.923 241.712 169.808 238.346 169.808C234.981 169.808 232.096 166.923 232.096 163.558C232.096 160.192 234.981 157.308 238.346 157.308C241.712 157.308 244.596 160.192 244.596 163.558Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.865 157.308C241.231 157.308 244.115 160.192 244.115 163.558C244.115 166.923 241.231 169.808 237.865 169.808",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.462 162.596C236.524 162.596 237.385 161.735 237.385 160.673C237.385 159.611 236.524 158.75 235.462 158.75C234.399 158.75 233.538 159.611 233.538 160.673C233.538 161.735 234.399 162.596 235.462 162.596Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.75 167.404C241.281 167.404 241.712 166.973 241.712 166.442C241.712 165.911 241.281 165.481 240.75 165.481C240.219 165.481 239.788 165.911 239.788 166.442C239.788 166.973 240.219 167.404 240.75 167.404Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.769 212.596C429.852 212.596 451.808 190.641 451.808 163.558C451.808 136.474 429.852 114.519 402.769 114.519C375.686 114.519 353.731 136.474 353.731 163.558C353.731 190.641 375.686 212.596 402.769 212.596Z",
    fill: "#0B6382"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M402.769 217.885C429.852 217.885 451.808 195.929 451.808 168.846C451.808 141.763 429.852 119.808 402.769 119.808C375.686 119.808 353.731 141.763 353.731 168.846C353.731 195.929 375.686 217.885 402.769 217.885Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.769 114.519C429.692 114.519 451.808 136.635 451.808 163.558C451.808 190.481 429.692 212.596 402.769 212.596",
    fill: "#00233F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.769 196.731C421.09 196.731 435.942 181.879 435.942 163.558C435.942 145.237 421.09 130.385 402.769 130.385C384.448 130.385 369.596 145.237 369.596 163.558C369.596 181.879 384.448 196.731 402.769 196.731Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.769 196.731C421.09 196.731 435.942 181.879 435.942 163.558C435.942 145.237 421.09 130.385 402.769 130.385C384.448 130.385 369.596 145.237 369.596 163.558C369.596 181.879 384.448 196.731 402.769 196.731Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.212 140C392.192 127.019 413.346 127.019 426.327 140C439.308 152.981 439.308 174.135 426.327 187.115",
    fill: "#EFEBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.769 139.038C420.558 139.038 434.981 147.692 435.942 165.481C435.942 165 435.942 164.038 435.942 163.558C435.942 145.288 421.038 130.385 402.769 130.385C384.5 130.385 369.596 145.288 369.596 163.558C369.596 164.038 369.596 165 369.596 165.481C370.558 148.173 384.981 139.038 402.769 139.038Z",
    fill: "#CCCAC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.673 124.135C393.735 124.135 394.596 123.274 394.596 122.212C394.596 121.149 393.735 120.288 392.673 120.288C391.611 120.288 390.75 121.149 390.75 122.212C390.75 123.274 391.611 124.135 392.673 124.135Z",
    fill: "#CCCAC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.769 124.135C403.831 124.135 404.692 123.274 404.692 122.212C404.692 121.149 403.831 120.288 402.769 120.288C401.707 120.288 400.846 121.149 400.846 122.212C400.846 123.274 401.707 124.135 402.769 124.135Z",
    fill: "#CCCAC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.865 124.135C413.927 124.135 414.788 123.274 414.788 122.212C414.788 121.149 413.927 120.288 412.865 120.288C411.803 120.288 410.942 121.149 410.942 122.212C410.942 123.274 411.803 124.135 412.865 124.135Z",
    fill: "#CCCAC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.019 163.558C409.019 166.923 406.135 169.808 402.769 169.808C399.404 169.808 396.519 166.923 396.519 163.558C396.519 160.192 399.404 157.308 402.769 157.308C406.135 157.308 409.019 160.192 409.019 163.558Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.769 157.308C406.135 157.308 409.019 160.192 409.019 163.558C409.019 166.923 406.135 169.808 402.769 169.808",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.365 162.596C401.427 162.596 402.288 161.735 402.288 160.673C402.288 159.611 401.427 158.75 400.365 158.75C399.303 158.75 398.442 159.611 398.442 160.673C398.442 161.735 399.303 162.596 400.365 162.596Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.173 167.404C405.704 167.404 406.135 166.973 406.135 166.442C406.135 165.911 405.704 165.481 405.173 165.481C404.642 165.481 404.212 165.911 404.212 166.442C404.212 166.973 404.642 167.404 405.173 167.404Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5 103.462C234.5 101.058 236.423 98.6539 238.827 98.6539H405.654C408.058 98.6539 409.981 101.058 409.981 102.981",
    fill: "#36FFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.462 247.692H283.538V252.5H360.462V247.692Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.269 290.962H221.038V310.192H240.269V290.962Z",
    fill: "#A0D827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.462 300.577L221.038 307.308V290.962H235.462V300.577Z",
    fill: "#CFF23B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.308 290.962H245.077V310.192H264.308V290.962Z",
    fill: "#F2AE16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.5 300.577L245.077 307.308V290.962H259.5V300.577Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.154 293.365C418.154 294.808 417.192 295.769 415.75 295.769H382.096C380.654 295.769 379.692 294.808 379.692 293.365C379.692 291.923 380.654 290.962 382.096 290.962H415.75C417.192 290.962 418.154 291.923 418.154 293.365Z",
    fill: "#36FFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.154 307.788C418.154 309.231 417.192 310.192 415.75 310.192H382.096C380.654 310.192 379.692 309.231 379.692 307.788C379.692 306.346 380.654 305.385 382.096 305.385H415.75C417.192 305.385 418.154 306.346 418.154 307.788Z",
    fill: "#36FFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.154 322.212C418.154 323.654 417.192 324.615 415.75 324.615H382.096C380.654 324.615 379.692 323.654 379.692 322.212C379.692 320.769 380.654 319.808 382.096 319.808H415.75C417.192 319.808 418.154 320.769 418.154 322.212Z",
    fill: "#36FFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.846 193.365L322 222.212L293.154 193.365L322 202.5L350.846 193.365Z",
    fill: "#F45683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.846 193.365L322 222.212L293.154 193.365L322 210.673L350.846 193.365Z",
    fill: "#E2336D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 118.846C327.045 118.846 331.135 114.756 331.135 109.712C331.135 104.667 327.045 100.577 322 100.577C316.955 100.577 312.865 104.667 312.865 109.712C312.865 114.756 316.955 118.846 322 118.846Z",
    fill: "#F45683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.135 109.712C331.135 114.519 327.288 118.846 322 118.846C316.712 118.846 312.865 115 312.865 109.712",
    fill: "#E2336D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.442 180.385C323.442 180.865 322.962 181.827 322 181.827C321.519 181.827 320.558 181.346 320.558 180.385V117.404C320.558 116.923 321.038 115.962 322 115.962C322.481 115.962 323.442 116.442 323.442 117.404V180.385Z",
    fill: "#E2336D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_3654",
    x1: 517.791,
    y1: 295.435,
    x2: 517.791,
    y2: 245.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3939D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AA2E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_3654",
    x1: 130.331,
    y1: 60,
    x2: 130.331,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3939D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AA2E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_3654",
    x1: 72,
    y1: 370.773,
    x2: 72,
    y2: 340.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3939D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AA2E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_3654",
    x1: 3,
    y1: 150.883,
    x2: 3,
    y2: 225.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D621C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54D7D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8_3654",
    x1: 379,
    y1: 333,
    x2: 379,
    y2: 403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D621C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54D7D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8_3654",
    x1: 505,
    y1: 2,
    x2: 505,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D621C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54D7D6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_3654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white",
    transform: "translate(172 40)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/Robot.5952aad0f3f0574da056ed6c475fb5c1.svg";
export { ForwardRef as ReactComponent };